import { useEffect, useState } from "react";
import Tabs from "../../Shared/Tab/Tab";
import PageHeader from "../../Layout/PageHeader";
import FormButton from "../../Components/Buttons/FormButton";
import { useNavigate, useParams } from "react-router-dom";
// import pngIcon from "../../../assets/images/xbox.png";
import { getItemById } from "./service/items.service";
import toast from "react-hot-toast";
import { ItemDetails } from "./model/items.model";
import Loader from "../../Components/GlobalLoader/Loader";

export default function ItemsDetails() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Items`;
  const [data, setData] = useState<ItemDetails>();
  const [loading, setLoading] = useState(true);
console.log('data',data);

  useEffect(() => {
    if (id) {
      setLoading(true);
      loadItemData(id).then(() => {
        setLoading(false);
      });
    }
  }, [id]);
   
  const loadItemData = async (id: string) => {
    try {
      const response = await getItemById(id);
      if (response.data) {
        setData(response.data);
      }
    } catch (error) {
      toast.error('Error loading item data');
      console.error(error);
    }
  };
  const tabData = [
    {
      order: 0,
      label: "Level 1",
      content: (
        <div className="mb-2 mt-1 p-4 bg-white rounded">
          <div className="p-4">
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Unit UOM</small>
                </div>
                <div className="fs-15">Each - EA</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Length (IN)</small>
                </div>
                <div className="fs-15">8</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Cubic (IN)</small>
                </div>
                <div className="fs-15">640</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Height (IN)</small>
                </div>
                <div className="fs-15">8</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Weight (LB)</small>
                </div>
                <div className="fs-15">02</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Width (IN)</small>
                </div>
                <div className="fs-15">10</div>
              </div>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Level 2",
      content: (
        <div className="mb-2 mt-1 p-4 bg-white rounded">
          <div className="p-4">
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Unit UOM</small>
                </div>
                <div className="fs-15">Each - EA</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Conversion Qty</small>
                </div>
                <div className="fs-15">6</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Cont. Tare Wgt (LB)</small>
                </div>
                <div className="fs-15">3000</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Length (IN)</small>
                </div>
                <div className="fs-15">20</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Height (IN)</small>
                </div>
                <div className="fs-15">20</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Width (IN)</small>
                </div>
                <div className="fs-15">15</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Qty</small>
                </div>
                <div className="fs-15">1 (Inner Box - IB)</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Weight (LB)</small>
                </div>
                <div className="fs-15">05</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Cubic (IN)</small>
                </div>
                <div className="fs-15">6000</div>
              </div>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Level 3",
      content: (
        <div className="mb-2 mt-1 p-4 bg-white rounded">
          <div className="p-4">
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Unit UOM</small>
                </div>
                <div className="fs-15">Pallet - PLT</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Conversion Qty (CA)</small>
                </div>
                <div className="fs-15">100</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Cont. Tare Wgt (LB)</small>
                </div>
                <div className="fs-15">3000</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Length (IN)</small>
                </div>
                <div className="fs-15">80</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Height (IN)</small>
                </div>
                <div className="fs-15">80</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Width (IN)</small>
                </div>
                <div className="fs-15">15</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Qty</small>
                </div>
                <div className="fs-15">1 (Inner Box - IB)</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Weight (LB)</small>
                </div>
                <div className="fs-15">25</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Cubic (IN)</small>
                </div>
                <div className="fs-15">96000</div>
              </div>
            </div>
            <div className="row">
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">TI Quantities</small>
                </div>
                <div className="fs-15">-</div>
              </div>
              <div className="mb-5 col-4">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">HI Quantities</small>
                </div>
                <div className="fs-15">-</div>
              </div>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: false,
    },
  ];

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="mb-2 mt-1 p-3 h-100 bg-white rounded">
            <div className="p-3 d-flex flex-wrap">
              <div className="col-7">
                <div className="row">
                <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Client</small>
                    </div>
                    <div className="fs-15">
                      {data?.client?.name ? `${data?.client?.name}(${data?.client?.code})` : '-'}
                    </div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Code</small>
                    </div>
                    <div className="fs-15">{data?.code ? data?.code : '-'}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">
                        Item Description
                      </small>
                    </div>
                    <div className="fs-15">{data?.description ? data?.description : '-'}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Category</small>
                    </div>
                    <div className="fs-15">{data?.item_category ? data?.item_category : '-'}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Group</small>
                    </div>
                    <div className="fs-15">{data?.item_group ? data?.item_group : '-'}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">HTS Code</small>
                    </div>
                    <div className="fs-15">{data?.hts_code ? data?.hts_code : '-'}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Sale Price ($)</small>
                    </div>
                    <div className="fs-15">$ {data?.unit_price}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Base Cost ($)</small>
                    </div>
                    <div className="fs-15">$ {data?.unit_cost}</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">
                        Average Cost ($)
                      </small>
                    </div>
                    <div className="fs-15">$ {data?.average_unit_cost}</div>
                  </div>
                </div>
              </div>
              <div className="col-5">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Item Image</small>
                </div>
                <div className="mt-1">
                {
                  data?.logo?.url ? (
                    <a href={data?.logo?.url} target="_blank">
                      <img className="item-image" src={data?.logo?.url} />
                    </a>
                  ) : (
                    <img height={200} width={200} src={require('../../assets/images/noimage.png')} />
                  )
                }
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(`/account/client/items/edit/${id}`);
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="d-flex mb-2 mt-1 h-100 gap-2">
            <div className="mt-1 p-3 bg-white rounded col-10">
              <div className="p-3 ">
                <div className="row">
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Min Stock Level</small>
                    </div>
                    <div className="fs-15">{data?.min_stock_level ? data?.min_stock_level : 0}</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Max Stock Level</small>
                    </div>
                    <div className="fs-15">{data?.max_stock_level ? data?.max_stock_level : 0}</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">
                        Sugg. Stock Level
                      </small>
                    </div>
                    <div className="fs-15">{data?.suggested_stock_level ? data?.suggested_stock_level : 0}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Popularity</small>
                    </div>
                    <div className="fs-15">{data?.popularity?.description ? data?.popularity?.description : '-'}</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">
                        FIFO/LIFO Method
                      </small>
                    </div>
                    <div className="fs-15">{data?.fifo_method?.description ? data?.fifo_method?.description : '-'}</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">FIFO Date Method</small>
                    </div>
                    <div className="fs-15">{data?.fifo_date_method?.description ? data?.fifo_date_method?.description : '-'}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">
                        Country Of Origin
                      </small>
                    </div>
                    <div className="fs-15">US</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Shelf Life</small>
                    </div>
                    <div className="fs-15">{data?.shelf_life ? data?.shelf_life : 0}</div>
                  </div>
                  <div className="mb-5 col">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Ship Life</small>
                    </div>
                    <div className="fs-15">{data?.ship_life ? data?.ship_life : 0}</div>
                  </div>

                </div>
              </div>
            </div>
            <div className="mt-1 p-3 bg-white rounded col">
              <div className="row p-2">
                <div className="mb-5 col-12">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Tag #</small>
                  </div>
                  <div className="form-check form-switch sidebar-toggler mt-auto pb-2">
                    <input
                      className="form-check-input toggle-button-size mt-2"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={data?.is_tag_tracking}
                    />
                  </div>
                </div>
                <div className="mb-5 col-12">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Lot #</small>
                  </div>
                  <div className="form-check form-switch sidebar-toggler mt-auto pb-2">
                    <input
                      className="form-check-input toggle-button-size mt-2"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={data?.is_lot_tracking}
                    />
                  </div>
                </div>
                <div className="mb-4 col-12">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Expiry Tracking</small>
                  </div>
                  <div className="fs-15">
                    {" "}
                    <div className="form-check form-switch sidebar-toggler mt-auto pb-2">
                      <input
                        className="form-check-input toggle-button-size mt-2"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={data?.is_expiry_tracking}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(
                    `/account/client/items/edit/${id}`
                  );
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Order Attribute",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="mb-2 mt-1 p-4 h-100 bg-white rounded">
            <div className="p-4">
              <div className="row">
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 01</small>
                  </div>
                  <div className="fs-15">Lorem ipsum</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 02</small>
                  </div>
                  <div className="fs-15">Lorem ipsum</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 03</small>
                  </div>
                  <div className="fs-15">Lorem ipsum</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 04</small>
                  </div>
                  <div className="fs-15">Lorem ipsum</div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(
                    `/account/client/items/edit/${id}`
                  );
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>
      ),
      hidden: true,
      visibility: true,
      status: true,
    },
    {
      order: 3,
      label: "UOM Setup",
      content: (
        <>
          <div className="mb-2 mt-1 p-4 bg-white rounded">
            <div className="px-4">
              <div className="row">
                <div className="mb- col py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Item Code</small>
                  </div>
                  <div className="fs-15">23332</div>
                </div>
                <div className="mb- col py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Item Description</small>
                  </div>
                  Google Pixel 4
                </div>

                <div className="mb- col py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Item Type</small>
                  </div>
                  <div className="fs-15">Components</div>
                </div>
                <div className="mb- col py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Item UOM Level</small>
                  </div>
                  <div className="fs-15">3</div>
                </div>
              </div>
            </div>
          </div>
          <>
            <div className="d-flex flex-column h-100">
              <Tabs
                tabs={tabData}
                isCheckbox={false}
                activeTabClass="d-flex flex-column h-100"
                tabLabelClass="d-flex flex-column h-100"
              />
            </div>
          </>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(
                    `/account/client/items/edit/${id}`
                  );
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </>
      ),
      hidden: true,
      visibility: true,
      status: true,
    },
  ];

  return !loading ? (
    <div className="col d-flex flex-column">
      <PageHeader
        addUrl="/inventory/assembly/kitting/details/:id"
        listUrl="/inventory/assembly/kitting"
        viewType={true}
        isHistoryEnabled={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName} ({data?.code})</h5>
      <div className="d-flex flex-column h-100">
        <Tabs
          tabs={tabs}
          isCheckbox={false}
          activeTabClass="d-flex flex-column h-100"
          tabLabelClass="d-flex flex-column h-100"
        />
      </div>
    </div>
  ):<Loader/>;
}
